// extracted by mini-css-extract-plugin
export var title = "partners-module--title--2z6J4";
export var logoContainer = "partners-module--logoContainer--DGcIv";